import { useContext, useEffect } from 'react';

import { TourContext } from '@/views/AdminDashboard/context/TourContext';
import type {
  OptionsProps,
  StepProps,
  TourContextState,
} from '@/views/AdminDashboard/context/TourContext/types';

const useTour = (
  steps?: StepProps[],
  defaultOptions?: OptionsProps,
): TourContextState => {
  const tourContext = useContext<TourContextState | null>(TourContext);

  if (tourContext === undefined || tourContext === null) {
    throw new Error('useTour must be used within an TourProvider');
  }

  const { setSteps, setOptions } = tourContext;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(() => {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (steps) setSteps(steps);
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (defaultOptions) setOptions(defaultOptions);
  }, []);

  return tourContext;
};

export default useTour;
